import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import generateValidator from './Validations/generateValidator';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import Section from './Section.js';
import AttributeOptions from './AttributeOptions.js';
import CustomSpinner from './CustomSpinner.js';
import SaveStepButton from './SaveStepButton';

class StartupForm extends Component {
    constructor(props){
        super(props);

        this.state = {
            accept_startup: null,
        };
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;
        const startup_options = [{id:0 , name:'Si'}, {id:1 , name:'No'}]

        return (

             <Section className="intro_form">
                <div className="row">
                <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                    <div className="show-desktop">
                        <SaveStepButton/>
                    </div>
                    </div>
                     <div className="pd-content-right text-center short-content col-sm-12 col-md-7 col-lg-7">
                         <form onSubmit={handleSubmit(this.props.acceptStartup)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <AttributeOptions name="startup" defaultValue="¿Sos una PyME nueva?" label="¿Sos una PyME nueva?" attributeName='startup' attributeOptions={startup_options}/>
                                    </div>
                                </div>
                            </div>
                            <FormattedHTMLMessage id="app.step_startup_info" description="Startup Info"/>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                                </div>
                            </div>
                        </form>
                        <div className="show-mobile">
                          <SaveStepButton/>
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

StartupForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

StartupForm = TopScrolleable(StartupForm);
let validate = generateValidator([{name: 'startup', required: true}]);

StartupForm = reduxForm({
    form: 'StartupForm', // a unique name for this form
    validate
})(StartupForm);

StartupForm = withAuthControl(StartupForm);

export default StartupForm;



/** WEBPACK FOOTER **
 ** ./src/components/StartupForm.js
 **/